module.exports = __webpack_public_path__ + "img/available.8468b8ac.svg";